module.exports = __webpack_public_path__ + "d5244075df5428a644ff2004096110c2.woff2";